<template>
  <div class="logout-button-wrapper">
    <VaButton preset="secondary" color="textPrimary" @click="logout">
      <span class="logout-button__anchor min-w-max">
        <VaIcon name="mso-logout" class="mr-1" />
        {{ t('user.logout') }}
      </span>
    </VaButton>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useKeycloak } from '@josempgon/vue-keycloak'

const { keycloak } = useKeycloak()
const { t } = useI18n()
const router = useRouter()

// Function to handle logout
const logout = async () => {
  try {
    keycloak.value?.logout()
  } catch (error) {
    console.error('Error during logout:', error)
    // If there's an error, still try to redirect to the users page
    router.push('/users')
  }
}
</script>

<style lang="scss">
.logout-button-wrapper {
  cursor: pointer;

  .logout-button__anchor {
    display: inline-flex;
    align-items: center;
  }
}
</style>
